"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _AddCircle = _interopRequireDefault(require("@material-ui/icons/AddCircle"));

var AccountImportButton = function AccountImportButton(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: "flex items-center text-primary font-bold mb-5 cursor-pointer"
  }, props), /*#__PURE__*/_react["default"].createElement("span", {
    className: "mr-2"
  }, /*#__PURE__*/_react["default"].createElement(_AddCircle["default"], null)), t('retrofit.accounts.import')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs text-light"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "retrofit.accounts.import.description"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold text-dark"
  }))));
};

var _default = AccountImportButton;
exports["default"] = _default;
//# sourceMappingURL=AccountImportButton.js.map